import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const LoginPrompt = () => {
  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate('/login');
  };

  return (
    <div className="text-center pt-6 border-t border-border">
      <p className="text-text-secondary text-sm mb-4">
        Already have an account?
      </p>
      
      <Button
        variant="outline"
        size="default"
        onClick={handleLoginClick}
        className="transition-micro hover-lift"
      >
        Sign In to Your Account
      </Button>
    </div>
  );
};

export default LoginPrompt;